import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useCallback, useMemo, useRef, useState } from 'react';
import { ChangeStatusBarParams } from 'ui-hooks/useInAppStatusBar';
import { Color } from '@diritto/common/style/color';

export const MODAL_ANIMATED_TIME = 0.15; // 0.15sec

export const useShowModal = (
  changeStatusBarParams?: ChangeStatusBarParams,
  prevChangeStatusBarParams?: ChangeStatusBarParams,
) => {
  const memoChangeStatusBarParams = useMemo(
    (): ChangeStatusBarParams => ({
      backgroundColor: '#B2B5B8',
      isModal: true,
      barStyle: 'dark-content',
      ...(changeStatusBarParams || {}),
    }),
    [changeStatusBarParams],
  );
  const memoPrevChangeStatusBarParams = useMemo(
    (): ChangeStatusBarParams => ({
      backgroundColor: Color.White,
      barStyle: 'dark-content',
      ...(prevChangeStatusBarParams || {}),
    }),
    [prevChangeStatusBarParams],
  );

  const [isShow, setIsShow] = useState(false);
  const [revealModal, setRevealModal] = useState(false);
  const hideTimeout = useRef<NodeJS.Timeout>(null);

  const showModal = useCallback(() => {
    // 숨겨지고 있는 동안에 다시 모달을 띄워야 한다면 기존의 timeout 을 제거한다.
    if (hideTimeout.current) {
      clearTimeout(hideTimeout.current);
    }
    setIsShow(true);
    setTimeout(() => {
      DirittoAppBridge.changeStatusBar(memoChangeStatusBarParams);
      setRevealModal(true);
    }, 0);
  }, [memoChangeStatusBarParams]);

  const hideModal = useCallback(() => {
    setRevealModal(false);
    hideTimeout.current = setTimeout(() => {
      DirittoAppBridge.changeStatusBar(memoPrevChangeStatusBarParams);
      setIsShow(false);
    }, MODAL_ANIMATED_TIME * 1000);
  }, [memoPrevChangeStatusBarParams]);

  return {
    isShow,
    revealModal,
    showModal,
    hideModal,
  };
};
